<template>
    <div class="jump-order nav-bar-fixed">
        <van-nav-bar title="积分明细" left-arrow fixed
                     @click-left="back"
        />
        <div class="integral-header">
            <van-circle
                    v-model="currentRate"
                    :rate="100"
                    :speed="0"
                    color="#fff"
                    size="120px"
                    layer-color="#fff"
                    :stroke-width="60"
            >
                <div class="circle-text">
                    <p>{{integral}}</p>
                    <span>可用积分</span>
                </div>
            </van-circle>
        </div>
        <div class="integral-detail">
            <h5  >全部记录</h5>

            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >

                <van-row class="integral-detail-item" v-for="item in list"  @click.native="goDetail(item.typeDetail,item.createTime)">
                    <van-col span="8">
                        <p class="detail-num add">{{item.integral}}</p>
                    </van-col>
                    <van-col span="8" >
                        <p>{{item.typeDetailView}}</p>
                    </van-col>
                    <van-col span="8" class="text-right">
                        {{item.createTime}}
                    </van-col>
                </van-row>
            </van-list>
        </div>
    </div>
</template>
<script>
    import {NavBar, Circle, Row, Col,List} from "vant";

    export default {
        name: "userintegral",
        components: {
            [NavBar.name]: NavBar,
            [Circle.name]: Circle,
            [Row.name]: Row,
            [List.name]: List,
            [Col.name]: Col
        },
        data() {
            return {
                integral: "",
                currentRate: 0,
                list: [],
                loading: false,
                finished: false,
                total: 0,
                page: 1,
                userRole:localStorage.getItem('userRole')?localStorage.getItem('userRole'):''
            };
        },
        mounted() {
            let that = this;
            this.$api.get(that.jumuc.userCenter.getUserInfo, null,
                successRes => {
                    // console.log(successRes)
                    if (successRes.success) {
                        that.integral = successRes.data.user.integral
                    }
                })
        },
        methods: {
            goDetail (type,time){//跳到积分统计
               if(type=='5'&&this.userRole.indexOf('BUYER')>-1){//买家
                    location.href = "#/user/order/intergral?time="+time;
               }else if(type=='16'&&this.userRole.indexOf('BM')>-1){//业务员
                   location.href = "#/user/order/intergral2?time="+time+'&role=BM';
               }else if(type=='16'&&this.userRole.indexOf('ECENGINEER')>-1){//电商工程师
                    location.href = "#/user/order/intergral2?time="+time+'&role=ECENGINEER';
               }
            },
            back() {
                history.back();
            }, onLoad() {
                let that = this
                // 异步更新数据
                that.$api.get(
                    that.jumuc.userCenter.integralLogPageList,
                    {"currentPageNo": that.page, "userId": localStorage.getItem("userId"),"source":1},
                    successRes => {
                        let orderlist = successRes.data.records
                        for (let i = 0; i < orderlist.length; i++) {
                            that.list.push(orderlist[i]);
                        }
                        that.page = successRes.data.pageInfo.currentPageNo
                        that.total = successRes.data.pageInfo.total
                        // 加载状态结束
                        that.loading = false;

                        // 数据全部加载完成
                        if (that.list.length >= that.total) {
                            that.finished = true;
                        }
                    }
                )

            }
        }
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3c6eeb;
    body {
        background-color: #f7f7f7;
    }

    .van-hairline--bottom::after {
        border-width: 0px;
    }

    .jump-order {

        .integral-header {
            background-color: @bule-thame;
            text-align: center;
            padding: 20px 0 60px;
            position: relative;
            .circle-text {
                height: 120px;
                color: #fff;
                position: relative;
                p {
                    font-size: 26px;
                    line-height: 100px;
                }
                span {
                    position: absolute;
                    bottom: 30px;
                    left: 35px;
                    font-size: 14px;
                }
            }
        }
        .integral-detail {
            background-color: #fff;
            margin-top: 10px;
            padding: 10px 15px 20px;
            h5 {
                font-size: 16px;
                padding: 10px 0;
                border-bottom: 1px solid #ebedf0;
                color: #333;
            }
            &-item {
                border-bottom: 1px dashed #ebedf0;
                padding: 20px 0 10px;
                color: #ccc;
                p {
                    font-size: 16px;
                    color: #333;
                }
                .detail-num {
                    font-size: 20px;
                    &.add {
                        color: #f5a623;
                    }
                    &.plus {
                        color: #ccc;
                    }
                }
            }
        }
        .detail-no-more {
            text-align: center;
            padding: 10px;
            font-size: 14px;
            color: #ccc;
        }
    }
 
</style>


